<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <loading
      :active="loading"
      :can-cancel="false"
      :is-full-page="true"
      color="#7367F0"
    />
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Reset Password</h4>
                  <vs-input
                    v-validate="'required'"
                    label="Email Address"
                    class="w-full"
                    placeholder="Enter your email address to reset your password"
                    v-model="form.email"
                    type="email"
                    name="email"
                  />
                  <span
                    class=" ml-1 text-danger text-sm"
                    v-show="errors.has('email')"
                    >You need to enter your email address</span
                  >
                  <span class=" ml-1 text-danger text-sm" v-show="invalidEmail"
                    >You need to format this email address correctly</span
                  >
                  <div class="mt-4 flex flex-row justify-around">
                    <div class="flex flex-col">
                      <vs-button @click="resetPassword"
                        >Reset Password</vs-button
                      >
                      <div class="flex flex-row justify-around">
                        <router-link class="mt-2" to="/login"
                          >Login</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { firebase } from "@/utilities/firebase";
import { mapState } from "vuex";
import Loading from "vue-loading-overlay";

export default {
  name: "ResetPassword",
  components: {
    Loading
  },
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      loading: false,
      invalidEmail: false
    };
  },
  computed: {
    ...mapState(["AppActiveUser"])
  },
  methods: {
    resetPassword() {
      this.$validator
        .validateAll()
        .then(result => {
          if (result) {
            this.loading = true;
            firebase
              .auth()
              .sendPasswordResetEmail(this.form.email)
              .then(() => {
                this.resetEmailDidSend();
              })
              .catch(error => {
                const errorCode = error.code;

                if (errorCode === "auth/invalid-email") {
                  this.emailIsInvalid();
                } else {
                  this.resetEmailDidSend();
                }
              });
          } else {
            console.error(result);
          }
        })
        .catch();
    },
    resetEmailDidSend() {
      this.loading = false;

      this.$vs.notify({
        title: "Success!",
        text:
          "If the email address you entered is linked to a user account, a password reset email will be sent to you shortly. Please remember to check your spam folder",
        color: "success",
        position: "top-right",
        time: 10000
      });
    },
    emailIsInvalid() {
      this.loading = false;
      this.invalidEmail = true;

      this.$vs.notify({
        title: "Invalid Email",
        text:
          "The email address you entered does not seem to be formatted correctly.",
        color: "warning",
        position: "top-right"
      });
    }
  }
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
